import { createStyles, makeStyles } from "@material-ui/core/styles";

import { AgeEstimationResult } from "../../../models/log";
import { ModelLabelProps } from "../../../config/modelsConfig";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) =>
  createStyles({
    predictionValue: {
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.body2.fontSize,
      },
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.common.black,
      marginLeft: 6,
    },
    stDev: {
      color: theme.palette.primary.main,
      marginLeft: "1ch",
      fontWeight: theme.typography.fontWeightLight,
    },
  }),
);

export const AgeResult: React.FC<ModelLabelProps> = (props) => {
  const classes = useStyles(props);
  const res = props.result as AgeEstimationResult;

  return (
    <>
      <Typography color="textSecondary" className={classes.predictionValue}>
        <>
          <span>{res.age.toFixed(2)} years</span>
          <span className={classes.stDev}>{res.stDev.toFixed(3)}</span>
        </>
      </Typography>
    </>
  );
};
